import store from '@/store/store'

class ConversationDetailModule {

  setMessages(messages) {
    store.commit('MESSAGE_LIST_SET', messages)
  }

  getMessages = () => store.state.conversationDetail.messageList

  setRequests(requests) {
    store.commit('REQUEST_LIST_SET', requests)
  }

  getRequests = () => store.state.conversationDetail.requestList
}

export default new ConversationDetailModule()
